import PageManipulationFlyout from './PageManipulationFlyout';

export default PageManipulationFlyout;